import { gql } from 'graphql-tag';

import { AccordionBlockFragment } from '@/components/common/blocks/AccordionBlock';
import { AccordionFragment } from '@/components/common/blocks/Accordion';
import { AddOnTrainingChapterFragment } from '@/components/common/blocks/AddOnTrainingChapter';
import { AlsoBoughtFragment } from '@/components/common/blocks/AlsoBought';
import { AppCtaFragment } from '@/components/common/blocks/AppCta';
import { ArticleChapterFragment } from '@/components/common/blocks/ArticleChapter';
import { ArticleRowSlideFragment } from '@/components/common/blocks/ArticleRowSlide';
import { AsSeenInFragment } from '@/components/common/blocks/AsSeenIn';
import { CampaignGridFragment } from '@/components/common/blocks/CampaignGrid';
import { CategoryBarIconsFragment } from '@/components/common/blocks/CategoryBarIcons';
import { CenteredContentFragment } from '@/components/common/blocks/CenteredContent';
import { CollectionInformationFragment } from '@/components/common/blocks/CollectionInformation';
import { LinksDisplayFragment } from '~/components/common/blocks/LinksDisplay';
import { CollectionTitleFragment } from '@/components/common/blocks/CollectionTitle';
import { CompareContentSliderFragment } from '@/components/common/blocks/CompareContentSlider';
import { CompareTableFragment } from '@/components/common/blocks/CompareTable';
import { ContactBlockFragment } from '@/components/common/blocks/ContactBlock';
import { ContentListFragment } from '@/components/common/blocks/ContentList';
import { ContentRecommendationSlideFragment } from '@/components/common/blocks/ContentRecommendationSlide';
import { ContentWithIconsFragment } from '@/components/common/blocks/ContentWithIcons';
import { ConversionAreaOneFragment } from '@/components/common/blocks/ConversionAreaOne';
import { CopyTextFragment } from '@/components/common/blocks/CopyText';
import { CourseContentFragment } from '@/components/common/blocks/CourseContent';
import { CourseConversionBannerFragment } from '@/components/common/blocks/CourseConversionBanner';
import { CrossSellFragment } from '@/components/common/blocks/CrossSell';
import { ExerciseByProductSliderFragment } from '@/components/common/blocks/ExerciseByProductSlider';
import { ExerciseFragment } from '@/components/common/blocks/Exercise';
import { ExerciseRoutineCardsSliderWithTextFragment } from '@/components/common/blocks/ExerciseRoutineCardsSliderWithText';
import { ExerciseTeaserFragment } from '@/components/common/blocks/ExerciseTeaser';
import { ExpertDetailsListingFragment } from '@/components/common/blocks/ExpertDetailsListing';
import { ExpertTestimonialFragment } from '@/components/common/blocks/ExpertTestimonial';
import { ExploreMoreFragment } from '@/components/common/blocks/ExploreMore';
import { FeaturedArticlesSlideFragment } from '@/components/common/blocks/FeaturedArticlesSlide';
import { FeaturedExpertsFragment } from '@/components/common/blocks/FeaturedExperts';
import { FeatureHeadlineFragment } from '@/components/common/blocks/FeatureHeadline';
import { FeatureListFragment } from '@/components/common/blocks/FeatureList';
import { FeaturesRotationFragment } from '@/components/common/blocks/FeaturesRotation';
import { FeaturesWithIconsFragment } from '@/components/common/blocks/FeaturesWithIcons';
import { FiftyFiftyArticleTeaserFragment } from '@/components/common/blocks/FiftyFiftyArticleTeaser';
import { FiftyFiftyTeaserImageFragment } from '@/components/common/blocks/FiftyFiftyTeaserImage';
import { FiftyFiftyTeaserWithBulletsFragment } from '@/components/common/blocks/FiftyFiftyTeaserWithBullets';
import { FindTrainingFragment } from '@/components/common/blocks/FindTraining';
import { FixedBoxFeatureFragment } from '@/components/common/blocks/FixedBoxFeature';
import { FixedBoxImagesFragment } from '@/components/common/blocks/FixedBoxImages';
import { FixedBoxTopicFeatureFragment } from '@/components/common/blocks/FixedBoxTopicFeature';
import { FormInModalFragment } from '@/components/common/blocks/FormInModal';
import { FormLinkFragment } from '@/components/common/blocks/FormLink';
import { FullWidthAutoplayVideoFragment } from '@/components/common/blocks/FullWidthAutoplayVideo';
import { FullWidthBarWithCtaFragment } from '@/components/common/blocks/FullWidthBarWithCta';
import { FullWidthBrandFragment } from '@/components/common/blocks/FullWidthBrand';
import { FullWidthHeadingCtaFragment } from '@/components/common/blocks/FullWidthHeadingCta';
import { FullWidthImageCtaFragment } from '@/components/common/blocks/FullWidthImageCta';
import { FullWidthImageFragment } from '@/components/common/blocks/FullWidthImage';
import { FullWidthTeaserBoxFragment } from '@/components/common/blocks/FullWidthTeaserBox';
import { FullwidthTopicFeatureBarsFragment } from '@/components/common/blocks/FullwidthTopicFeatureBars';
import { GalleryFragment } from '@/components/common/blocks/Gallery';
import { GenericIframeFragment } from '@/components/common/blocks/GenericIframe';
import { HeroProductFragment } from '@/components/common/blocks/HeroProduct';
import { ImageOrVideoFragment } from '@/components/common/blocks/ImageOrVideo';
import { ImageTextFragment } from '@/components/common/blocks/ImageText';
import { ImageTextHoverFragment } from '@/components/common/blocks/ImageTextHover';
import { ImageTitleFeatureFragment } from '@/components/common/blocks/ImageTitleFeature';
import { InContentCtaFragment } from '@/components/common/blocks/InContentCta';
import { IncontentImageRowFragment } from '@/components/common/blocks/IncontentImageRow';
import { InsuranceReimbursementFragment } from '@/components/common/blocks/InsuranceReimbursement';
import { IntroductionPageCtaFragment } from '@/components/common/blocks/IntroductionPageCta';
import { JobsFragment } from '@/components/common/blocks/Jobs';
import { LargeExerciseRoutineSliderFragment } from '@/components/common/blocks/LargeExerciseRoutineSlider';
import { LargeHeadlineContentFragment } from '@/components/common/blocks/LargeHeadlineContent';
import { LargeImageFeatureFragment } from '@/components/common/blocks/LargeImageFeature';
import { LargeStoryFeatureWithBarsFragment } from '@/components/common/blocks/LargeStoryFeatureWithBars';
import { LargeTopicFeatureFragment } from '@/components/common/blocks/LargeTopicFeature';
import { MediumTopicFeatureFragment } from '@/components/common/blocks/MediumTopicFeature';
import { MixedStorySliderFragment } from '@/components/common/blocks/MixedStorySlider';
import { MovingFullWidthImagesFragment } from '@/components/common/blocks/MovingFullWidthImages';
import { NewsletterSignupFormFragment } from '@/components/common/blocks/NewsletterSignupForm';
import { NumberedImageFragment } from '@/components/common/blocks/NumberedImage';
import { NumbersOnBlackBackgroundFragment } from '@/components/common/blocks/NumbersOnBlackBackground';
import { ParallaxImagesFragment } from '@/components/common/blocks/ParallaxImages';
import { ProductFeatureThreeFragment } from '@/components/common/blocks/ProductFeatureThree';
import { ProductGridFragment } from '@/components/common/blocks/ProductGrid';
import { ProductInformationFragment } from '@/components/common/blocks/ProductInformation';
import { ProductListingFeatureFragment } from '@/components/common/blocks/ProductListingFeature';
import { ProductReviewsFragment } from '@/components/common/blocks/ProductReviews';
import { ProductSliderFragment } from '@/components/common/blocks/ProductSlider';
import { QuestionsAnswersFragment } from '@/components/common/blocks/QuestionsAnswers';
import { RelatedProductsFragment } from '@/components/common/blocks/RelatedProducts';
import { RoutineCardsSliderFragment } from '@/components/common/blocks/RoutineCardsSlider';
import { RoutineFiftyFiftyTeaserWithBulletsFragment } from '@/components/common/blocks/RoutineFiftyFiftyTeaserWithBullets';
import { RoutinesSportSliderFragment } from '@/components/common/blocks/RoutinesSportSlider';
import { ShareThisArticleFragment } from '@/components/common/blocks/ShareThisArticle';
import { SingleSocialMediaPostFragment } from '~/components/common/blocks/SingleSocialMediaPost';
import { SmallInContentCtaFragment } from '@/components/common/blocks/SmallInContentCta';
import { SmallInstructionFragment } from '@/components/common/blocks/SmallInstruction';
import { SmallStoryFeaturesWithBarsFragment } from '@/components/common/blocks/SmallStoryFeaturesWithBars';
import { SmallTopicFeatureBarsFragment } from '@/components/common/blocks/SmallTopicFeatureBars';
import { SmallTopicFeatureBoxFragment } from '@/components/common/blocks/SmallTopicFeatureBox';
import { SmallTopicFeatureFragment } from '@/components/common/blocks/SmallTopicFeature';
import { SocialFeatureFragment } from '@/components/common/blocks/SocialFeature';
import { SplitContentSliderFragment } from '@/components/common/blocks/SplitContentSlider';
import { StoryCategoryBlockFragment } from '@/components/common/blocks/StoryCategoryBlock';
import { StoryListFragment } from '@/components/common/blocks/StoryList';
import { StoryTeaserBlackFragment } from '@/components/common/blocks/StoryTeaserBlack';
import { TableFragment } from '@/components/common/blocks/Table';
import { TeaserWithCtaFragment } from '@/components/common/blocks/TeaserWithCta';
import { TeaserWithMultipleCtasFragment } from '@/components/common/blocks/TeaserWithMultipleCtas';
import { TestimonialFragment } from '@/components/common/blocks/Testimonial';
import { TestimonialWithVariedBackgroundFragment } from '@/components/common/blocks/TestimonialWithVariedBackground';
import { TextLeftImageRightFragment } from '@/components/common/blocks/TextLeftImageRight';
import { TimelineFragment } from '@/components/common/blocks/Timeline';
import { TwoPortraitImagesFragment } from '@/components/common/blocks/TwoPortraitImages';
import { UpsellFragment } from '@/components/common/blocks/Upsell';
import { ValueRotationFragment } from '@/components/common/blocks/ValueRotation';
import { VideoFeatureFragment } from '@/components/common/blocks/VideoFeature';
import { VideoRotationFragment } from '@/components/common/blocks/VideoRotation';
import { VideoWithDescriptionFragment } from '@/components/common/blocks/VideoWithDescription';

export const ContentBlocksMatrixFragment = gql`
  fragment ContentBlocksMatrixFragment on contentBlocks_MatrixField {
    __typename
    ...AccordionBlockFragment
    ...AccordionFragment
    ...AddOnTrainingChapterFragment
    ...AlsoBoughtFragment
    ...AppCtaFragment
    ...ArticleChapterFragment
    ...ArticleRowSlideFragment
    ...AsSeenInFragment
    ...CampaignGridFragment
    ...CategoryBarIconsFragment
    ...CenteredContentFragment
    ...CollectionInformationFragment
    ...LinksDisplayFragment
    ...CollectionTitleFragment
    ...CompareContentSliderFragment
    ...CompareTableFragment
    ...ContactBlockFragment
    ...ContentListFragment
    ...ContentRecommendationSlideFragment
    ...ContentWithIconsFragment
    ...ConversionAreaOneFragment
    ...CopyTextFragment
    ...CourseContentFragment
    ...CourseConversionBannerFragment
    ...CrossSellFragment
    ...ExerciseByProductSliderFragment
    ...ExerciseFragment
    ...ExerciseRoutineCardsSliderWithTextFragment
    ...ExerciseTeaserFragment
    ...ExpertDetailsListingFragment
    ...ExpertTestimonialFragment
    ...ExploreMoreFragment
    ...FeaturedArticlesSlideFragment
    ...FeaturedExpertsFragment
    ...FeatureHeadlineFragment
    ...FeatureListFragment
    ...FeaturesRotationFragment
    ...FeaturesWithIconsFragment
    ...FiftyFiftyArticleTeaserFragment
    ...FiftyFiftyTeaserImageFragment
    ...FiftyFiftyTeaserWithBulletsFragment
    ...FindTrainingFragment
    ...FixedBoxFeatureFragment
    ...FixedBoxImagesFragment
    ...FixedBoxTopicFeatureFragment
    ...FormInModalFragment
    ...FormLinkFragment
    ...FullWidthAutoplayVideoFragment
    ...FullWidthBarWithCtaFragment
    ...FullWidthBrandFragment
    ...FullWidthHeadingCtaFragment
    ...FullWidthImageCtaFragment
    ...FullWidthImageFragment
    ...FullWidthTeaserBoxFragment
    ...FullwidthTopicFeatureBarsFragment
    ...GalleryFragment
    ...GenericIframeFragment
    ...HeroProductFragment
    ...ImageOrVideoFragment
    ...ImageTextFragment
    ...ImageTextHoverFragment
    ...ImageTitleFeatureFragment
    ...InContentCtaFragment
    ...IncontentImageRowFragment
    ...InsuranceReimbursementFragment
    ...IntroductionPageCtaFragment
    ...JobsFragment
    ...LargeExerciseRoutineSliderFragment
    ...LargeHeadlineContentFragment
    ...LargeImageFeatureFragment
    ...LargeStoryFeatureWithBarsFragment
    ...LargeTopicFeatureFragment
    ...MediumTopicFeatureFragment
    ...MixedStorySliderFragment
    ...MovingFullWidthImagesFragment
    ...NewsletterSignupFormFragment
    ...NumberedImageFragment
    ...NumbersOnBlackBackgroundFragment
    ...ParallaxImagesFragment
    ...ProductFeatureThreeFragment
    ...ProductGridFragment
    ...ProductInformationFragment
    ...ProductListingFeatureFragment
    ...ProductReviewsFragment
    ...ProductSliderFragment
    ...QuestionsAnswersFragment
    ...RelatedProductsFragment
    ...RoutineCardsSliderFragment
    ...RoutineFiftyFiftyTeaserWithBulletsFragment
    ...RoutinesSportSliderFragment
    ...ShareThisArticleFragment
    ...SingleSocialMediaPostFragment
    ...SmallInContentCtaFragment
    ...SmallInstructionFragment
    ...SmallStoryFeaturesWithBarsFragment
    ...SmallTopicFeatureBarsFragment
    ...SmallTopicFeatureBoxFragment
    ...SmallTopicFeatureFragment
    ...SocialFeatureFragment
    ...SplitContentSliderFragment
    ...StoryCategoryBlockFragment
    ...StoryListFragment
    ...StoryTeaserBlackFragment
    ...TableFragment
    ...TeaserWithCtaFragment
    ...TeaserWithMultipleCtasFragment
    ...TestimonialFragment
    ...TestimonialWithVariedBackgroundFragment
    ...TextLeftImageRightFragment
    ...TimelineFragment
    ...TwoPortraitImagesFragment
    ...UpsellFragment
    ...ValueRotationFragment
    ...VideoFeatureFragment
    ...VideoRotationFragment
    ...VideoWithDescriptionFragment
  }
  # MARK: fragment imports
  ${AccordionBlockFragment}
  ${AccordionFragment}
  ${AddOnTrainingChapterFragment}
  ${AlsoBoughtFragment}
  ${AppCtaFragment}
  ${ArticleChapterFragment}
  ${ArticleRowSlideFragment}
  ${AsSeenInFragment}
  ${CampaignGridFragment}
  ${CategoryBarIconsFragment}
  ${CenteredContentFragment}
  ${CollectionInformationFragment}
  ${LinksDisplayFragment}
  ${CollectionTitleFragment}
  ${CompareContentSliderFragment}
  ${CompareTableFragment}
  ${ContactBlockFragment}
  ${ContentListFragment}
  ${ContentRecommendationSlideFragment}
  ${ContentWithIconsFragment}
  ${ConversionAreaOneFragment}
  ${CopyTextFragment}
  ${CourseContentFragment}
  ${CourseConversionBannerFragment}
  ${CrossSellFragment}
  ${ExerciseByProductSliderFragment}
  ${ExerciseFragment}
  ${ExerciseRoutineCardsSliderWithTextFragment}
  ${ExerciseTeaserFragment}
  ${ExpertDetailsListingFragment}
  ${ExpertTestimonialFragment}
  ${ExploreMoreFragment}
  ${FeaturedArticlesSlideFragment}
  ${FeaturedExpertsFragment}
  ${FeatureHeadlineFragment}
  ${FeatureListFragment}
  ${FeaturesRotationFragment}
  ${FeaturesWithIconsFragment}
  ${FiftyFiftyArticleTeaserFragment}
  ${FiftyFiftyTeaserImageFragment}
  ${FiftyFiftyTeaserWithBulletsFragment}
  ${FindTrainingFragment}
  ${FixedBoxFeatureFragment}
  ${FixedBoxImagesFragment}
  ${FixedBoxTopicFeatureFragment}
  ${FormInModalFragment}
  ${FormLinkFragment}
  ${FullWidthAutoplayVideoFragment}
  ${FullWidthBarWithCtaFragment}
  ${FullWidthBrandFragment}
  ${FullWidthHeadingCtaFragment}
  ${FullWidthImageCtaFragment}
  ${FullWidthImageFragment}
  ${FullWidthTeaserBoxFragment}
  ${FullwidthTopicFeatureBarsFragment}
  ${GalleryFragment}
  ${GenericIframeFragment}
  ${HeroProductFragment}
  ${ImageOrVideoFragment}
  ${ImageTextFragment}
  ${ImageTextHoverFragment}
  ${ImageTitleFeatureFragment}
  ${InContentCtaFragment}
  ${IncontentImageRowFragment}
  ${InsuranceReimbursementFragment}
  ${IntroductionPageCtaFragment}
  ${JobsFragment}
  ${LargeExerciseRoutineSliderFragment}
  ${LargeHeadlineContentFragment}
  ${LargeImageFeatureFragment}
  ${LargeStoryFeatureWithBarsFragment}
  ${LargeTopicFeatureFragment}
  ${MediumTopicFeatureFragment}
  ${MixedStorySliderFragment}
  ${MovingFullWidthImagesFragment}
  ${NewsletterSignupFormFragment}
  ${NumberedImageFragment}
  ${NumbersOnBlackBackgroundFragment}
  ${ParallaxImagesFragment}
  ${ProductFeatureThreeFragment}
  ${ProductGridFragment}
  ${ProductInformationFragment}
  ${ProductListingFeatureFragment}
  ${ProductReviewsFragment}
  ${ProductSliderFragment}
  ${QuestionsAnswersFragment}
  ${RelatedProductsFragment}
  ${RoutineCardsSliderFragment}
  ${RoutineFiftyFiftyTeaserWithBulletsFragment}
  ${RoutinesSportSliderFragment}
  ${ShareThisArticleFragment}
  ${SingleSocialMediaPostFragment}
  ${SmallInContentCtaFragment}
  ${SmallInstructionFragment}
  ${SmallStoryFeaturesWithBarsFragment}
  ${SmallTopicFeatureBarsFragment}
  ${SmallTopicFeatureBoxFragment}
  ${SmallTopicFeatureFragment}
  ${SocialFeatureFragment}
  ${SplitContentSliderFragment}
  ${StoryCategoryBlockFragment}
  ${StoryListFragment}
  ${StoryTeaserBlackFragment}
  ${TableFragment}
  ${TeaserWithCtaFragment}
  ${TeaserWithMultipleCtasFragment}
  ${TestimonialFragment}
  ${TestimonialWithVariedBackgroundFragment}
  ${TextLeftImageRightFragment}
  ${TimelineFragment}
  ${TwoPortraitImagesFragment}
  ${UpsellFragment}
  ${ValueRotationFragment}
  ${VideoFeatureFragment}
  ${VideoRotationFragment}
  ${VideoWithDescriptionFragment}
`;
